import React, { Component } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import {
  BrowserRouter as Router,
  Link,
  Redirect,
  Route,
} from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/DropdownStyles.css";
import "../css/Admin_css/demand-notice.css";
import myToast from "../Utils/MyToast";
import Iframe from "react-iframe";
import MdlSelectMultipleStudent from "../dialog/MdlSelectMultipleStudent";
import BackButton from "../ChildComponent/BackButton";
export default class DemandNotice extends Component {
  constructor(props) {
    super(props);

    const token = localStorage.getItem("token");
    let loggedIn = true;
    if (token == null) {
      loggedIn = false;
    }

    this.state = {
      loggedIn: true,
      Loading: false,
      isOpenSelectStudent: false,
      showStudentIdCard: false,
      Total: 0,
      mSelectedStudent: [],
      mPrintableSamples: [],
      mColorOption: [],
      mYearMonth: [],
      mOptions: [],
      selectedOption: "",
      iFrameHeight: "300px",
      SELECTED_SAMPLE_ID: "",
      SELECTED_SAMPLE_POSITION: 0,
      SELECTED_COLOR_POSITION: 0,
      SELECTION_TYPE: "",
      FILE_URL: "",
      FILE_NAME: "",
      FILE_DIRECTORY: "",
      DOCUMENT_TYPE: "",
      COLOR_OPTION_ID: "",
    };
    this.HandleSelectedStudent = this.HandleSelectedStudent.bind(this);
    this.HandleCloseSelectStudent = this.HandleCloseSelectStudent.bind(this);
  }
  componentDidMount() {
    const documentType = this.props.match.params.document_type;
    
    const mSession = SessionManager.getCurrentSession();
    if (!mSession) {
      myToast.notify_error("Session data not found. Please login again.");
      return;
    }
    
    const sessionData = Array.isArray(mSession) ? mSession[0] : mSession;
    if (!sessionData || !sessionData.start_date || !sessionData.end_date) {
      myToast.notify_error("Invalid session data. Please contact administrator.");
      return;
    }
    
    const start_date = new Date(sessionData.start_date);
    const end_date = new Date(sessionData.end_date);

    const mYearMonth = [];
    while (start_date <= end_date) {
      const year = start_date.getFullYear();
      const month = String(start_date.getMonth() + 1).padStart(2, "0");
      mYearMonth.push(`${year}-${month}`);
      start_date.setMonth(start_date.getMonth() + 1);
    }
    
    this.setState({
      DOCUMENT_TYPE: documentType,
      selectedOption: this.getCurrentYearMonth(),
      mOptions: mYearMonth,
    }, () => {
      this.getPrintableSamples();
    });

    // Listen for iframe height messages
    const handleMessage = (event) => {
      if (event.data && event.data.iframeHeight) {
        this.setState({ iFrameHeight: `${event.data.iframeHeight}px` });
      }
    };
    window.addEventListener("message", handleMessage, false);
    this.messageHandler = handleMessage;
  }

  componentWillUnmount() {
    if (this.messageHandler) {
      window.removeEventListener("message", this.messageHandler);
    }
  }

  getCurrentYearMonth = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Add leading zero to month
    return `${year}-${month}`;
  };
  HandleCloseSelectStudent = () => {
    this.setState({
      isOpenSelectStudent: false,
    });
  };

  HandleSelectedStudent = (mSelectedStudent) => {
    if (mSelectedStudent == null) {
      mSelectedStudent = [];
    }
    this.setState({
      isOpenSelectStudent: false,
      showStudentIdCard: true,
      mSelectedStudent: mSelectedStudent,
      SELECTION_TYPE: "student",
    }, () => {
      this.setFileUrL(mSelectedStudent);
    });
  };
  SelectStudent = () => {
    this.setState({
      isOpenSelectStudent: true,
    });
  };

  getPrintableSamples() {
    this.setState({
      Loading: true,
    });

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getPrintableSample.php";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    axios
      .get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          document_type: this.state.DOCUMENT_TYPE,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        this.setState({
          Loading: false,
        });

        if (response.api_status === "OK") {
          this.setState({
            mPrintableSamples: response.data,
          });
          this.setSample(this.state.SELECTED_SAMPLE_POSITION);
        } else {
          myToast.notify_warning(response.api_remark || "Failed to load printable samples");
        }
      })
      .catch((error) => {
        this.setState({
          Loading: false,
        });
        myToast.notify_error("Error loading printable samples");
      });
  }
  setSample(selected_sample_position) {
    if (!this.state.mPrintableSamples || this.state.mPrintableSamples.length === 0) {
      return;
    }
    
    const sample = this.state.mPrintableSamples[selected_sample_position];
    if (!sample) {
      return;
    }
    
    const sample_id = sample.sample_id;
    const FILE_NAME = sample.file_name;
    const FILE_DIRECTORY = sample.file_directory;
    
    this.setState({
      FILE_NAME: FILE_NAME,
      FILE_DIRECTORY: FILE_DIRECTORY,
      SELECTED_SAMPLE_ID: sample_id,
    }, () => {
      this.getColorOptions(selected_sample_position);
    });
  }
  
  getColorOptions(selected_sample_position) {
    if (!this.state.mPrintableSamples || this.state.mPrintableSamples.length === 0) {
      return;
    }
    
    const sample = this.state.mPrintableSamples[selected_sample_position];
    if (!sample) {
      return;
    }
    
    const mColorOption = sample.color_options || [];
    this.setState({
      mColorOption: mColorOption,
    }, () => {
      this.setColorOptions(
        this.state.SELECTED_COLOR_POSITION,
        this.state.FILE_NAME,
        this.state.FILE_DIRECTORY,
        this.state.SELECTED_SAMPLE_ID
      );
    });
  }
  
  setColorOptions(selected_position_color_option, fileName = this.state.FILE_NAME, fileDirectory = this.state.FILE_DIRECTORY, sampleId = this.state.SELECTED_SAMPLE_ID) {
    const mColorOption = this.state.mColorOption || [];
    const COLOR_OPTION_ID = mColorOption.length > 0 && mColorOption[selected_position_color_option]
      ? mColorOption[selected_position_color_option].color_option_id
      : "";

    this.setState({
      COLOR_OPTION_ID: COLOR_OPTION_ID,
    }, () => {
      if (this.state.mSelectedStudent.length !== 0) {
        this.setFileUrL(this.state.mSelectedStudent, fileName, fileDirectory, sampleId, COLOR_OPTION_ID);
      }
    });
  }
  setFileUrL(
    students = this.state.mSelectedStudent,
    fileName = this.state.FILE_NAME,
    fileDirectory = this.state.FILE_DIRECTORY,
    sampleId = this.state.SELECTED_SAMPLE_ID,
    colorOptionId = this.state.COLOR_OPTION_ID
  ) {
    if (!students || students.length === 0) {
      this.setState({ FILE_URL: "" });
      return;
    }

    if (!fileName || !fileDirectory || !sampleId) {
      return;
    }

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    if (!SCHOOL_CODE) {
      myToast.notify_error("School code not found. Please login again.");
      return;
    }

    const mStudentIds = students.map((s) => s.student_enrollment_no);
    const class_id = students[0]?.class_id || "";
    const section_id = students[0]?.section_id || "";
    const session_id = students[0]?.session_id || "";

    const url = `${process.env.REACT_APP_SERVER_NAME}${fileDirectory}${fileName}?student_ids=${encodeURIComponent(JSON.stringify(mStudentIds))}&class_id=${encodeURIComponent(class_id)}&section_id=${encodeURIComponent(section_id)}&session_id=${encodeURIComponent(session_id)}&selected_month=${encodeURIComponent(this.state.selectedOption)}&sample_id=${encodeURIComponent(sampleId)}&selection_type=${encodeURIComponent(this.state.SELECTION_TYPE)}&system_code=${encodeURIComponent(process.env.REACT_APP_SYSTEM_CODE)}&color_option_id=${encodeURIComponent(colorOptionId)}&school_code=${encodeURIComponent(SCHOOL_CODE)}`;

    console.log("Demand Notice URL:", url);
    this.setState({ 
      FILE_URL: url,
      showStudentIdCard: true,
    });
  }
  changeColor = (index) => {
    this.setState(
      {
        SELECTED_COLOR_POSITION: index,
        showStudentIdCard: true,
      },
      () => {
        this.setColorOptions(
          this.state.SELECTED_COLOR_POSITION,
          this.state.FILE_NAME,
          this.state.FILE_DIRECTORY,
          this.state.SELECTED_SAMPLE_ID
        );
      }
    );
  };
  
  changeSample(position) {
    this.setState(
      {
        SELECTED_SAMPLE_POSITION: position,
        showStudentIdCard: true,
      },
      () => {
        this.setSample(this.state.SELECTED_SAMPLE_POSITION);
      }
    );
  }
  autoResize = () => {
    //alert("loaded");
    var iFrame = document.getElementById("iFrame1");
  };
  handleChange = (event) => {
    const value = event.target.value;
    this.setState(
      {
        selectedOption: value,
      },
      () => {
        if (this.state.mSelectedStudent.length !== 0) {
          this.setFileUrL(this.state.mSelectedStudent);
        }
      }
    );
  };

  render() {
    if (this.state.loggedIn == false) {
      return <Redirect to="/Login" />;
    }
    if (this.state.Loading) {
      return <MyLoader />;
    } else {
      return (
        <div className="content demand-notice">
          <div
            className="content-header"
            style={{ background: COLORS.primary_color_shade5 }}
          >
            <div className="leftside-content-header">
              <ul className="breadcrumbs">
                <li>
                  <i
                    className="fa fa-home"
                    aria-hidden="true"
                    style={{ color: COLORS.white }}
                  />
                  <a href="#" style={{ color: COLORS.white }}>
                    {this.state.mPrintableSamples.length !== 0
                      ? this.state.mPrintableSamples[0].document_caption
                      : "Demand Notice"}
                  </a>
                </li>
              </ul>
            </div>
            <div className="rightside-content-header">
              <BackButton />
            </div>
          </div>

          <div className="page-card">
            {/* Modern Header Section */}
            <div className="header-section">
              <div className="header-content">
                <h5>
                  {this.state.mPrintableSamples.length !== 0
                    ? this.state.mPrintableSamples[0].document_caption
                    : "Demand Notice"}
                </h5>
                <small>Generate and manage demand notices for students</small>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                {this.state.mSelectedStudent.length > 0 ? (
                  <button
                    className="header-selection-button"
                    onClick={this.SelectStudent}
                  >
                    <i className="fa fa-edit" />
                    Change Selection ({this.state.mSelectedStudent.length})
                  </button>
                ) : (
                  <button
                    className="header-selection-button"
                    onClick={this.SelectStudent}
                  >
                    <i className="fa fa-user-plus" />
                    Select Students
                  </button>
                )}
                <div className="header-icon">
                  <i className="fa fa-file-invoice"></i>
                </div>
              </div>
            </div>

            {/* Selected Students Display */}
            {this.state.mSelectedStudent.length > 0 && (
              <div style={{ margin: "16px 20px 0 20px", padding: "12px", background: "#f8fafc", borderRadius: "8px", border: "1px solid #e5e7eb" }}>
                <div style={{ 
                  display: "flex", 
                  flexWrap: "wrap", 
                  gap: "8px", 
                  alignItems: "center"
                }}>
                  {this.state.mSelectedStudent.slice(0, 10).map((student, index) => (
                    <span 
                      key={index} 
                      style={{
                        background: "linear-gradient(135deg, #3b82f6 0%, #6366f1 100%)",
                        color: "#fff",
                        padding: "4px 10px",
                        borderRadius: "16px",
                        fontSize: "11px",
                        fontWeight: "600"
                      }}
                    >
                      {student.student_name}
                    </span>
                  ))}
                  {this.state.mSelectedStudent.length > 10 && (
                    <span style={{
                      background: "#e5e7eb",
                      color: "#374151",
                      padding: "4px 10px",
                      borderRadius: "16px",
                      fontSize: "11px",
                      fontWeight: "600"
                    }}>
                      +{this.state.mSelectedStudent.length - 10} more
                    </span>
                  )}
                </div>
              </div>
            )}

            {/* Month Selection Section */}
            <div className="selection-section" style={{ margin: "16px 20px 0 20px" }}>
              <h5 className="section-title">
                <i className="fa fa-calendar" style={{ marginRight: "6px" }} />
                Select Month
              </h5>
              <div className="templates-grid">
                {(this.state.mOptions || []).map((item, index) => {
                  const [year, month] = item.split("-");
                  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                  const monthName = monthNames[parseInt(month) - 1];
                  const isSelected = this.state.selectedOption === item;
                  
                  return (
                    <div
                      key={index}
                      className={`template-item month-item ${isSelected ? 'active' : ''}`}
                      onClick={() => {
                        this.setState({ selectedOption: item }, () => {
                          if (this.state.mSelectedStudent.length !== 0) {
                            this.setFileUrL(this.state.mSelectedStudent);
                          }
                        });
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: "8px", width: "100%" }}>
                        <i className="fa fa-calendar template-icon" style={{ color: isSelected ? "#10b981" : "#3b82f6" }}></i>
                        <div className="template-name">
                          <div style={{ fontSize: "12px", fontWeight: "600" }}>{monthName}</div>
                          <div style={{ fontSize: "10px", color: "#6b7280", marginTop: "2px" }}>{year}</div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Samples Section */}
            <div className="selection-section" style={{ margin: "16px 20px 0 20px" }}>
              <h5 className="section-title">
                <i className="fa fa-file-text" style={{ marginRight: "6px" }} />
                Demand Notice Samples
              </h5>
              <div className="templates-grid">
                {this.state.mPrintableSamples.map((item, index) => (
                  <div
                    key={index}
                    className={`template-item ${this.state.SELECTED_SAMPLE_POSITION === index ? 'active' : ''}`}
                    onClick={() => this.changeSample(index)}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", width: "100%" }}>
                      <i className="fa fa-file-text template-icon"></i>
                      <div className="template-name">{item.sample_name}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Color Options Section */}
            {this.state.mColorOption && this.state.mColorOption.length > 0 && (
              <div className="selection-section" style={{ margin: "16px 20px 0 20px" }}>
                <h5 className="section-title">
                  <i className="fa fa-paint-brush" style={{ marginRight: "6px" }} />
                  Color Options
                </h5>
                <div className="color-options">
                  {this.state.mColorOption.map((item, index) => {
                    const [color1, color2] = (item.sample_color_code || "").split("_");
                    return (
                      <div
                        key={index}
                        className={`color-option ${this.state.SELECTED_COLOR_POSITION === index ? 'active' : ''}`}
                        onClick={() => this.changeColor(index)}
                      >
                        <div className="color-display">
                          <div style={{ backgroundColor: color1 || "#000000" }}></div>
                          <div style={{ backgroundColor: color2 || color1 || "#000000" }}></div>
                        </div>
                        <div className="color-name">{item.sample_color_name}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Preview Section */}
            <div className="preview-section" style={{ margin: "16px 20px 20px 20px" }}>
              <h5 className="section-title">
                <i className="fa fa-eye" style={{ marginRight: "6px" }} />
                Preview
              </h5>
              <div className="preview-frame">
                {this.state.mSelectedStudent.length === 0 ? (
                  <div className="no-staff-message">
                    <i className="fa fa-user-plus" />
                    <h4>No Students Selected</h4>
                    <p>Please select students to preview the demand notice</p>
                  </div>
                ) : (
                  <>
                    {this.state.showStudentIdCard && <MyLoader />}
                    <Iframe
                      url={this.state.FILE_URL}
                      width="100%"
                      height={this.state.iFrameHeight}
                      style={{ border: "none", overflow: "hidden" }}
                      id="iFrameStudentId"
                      scrolling="no"
                      onLoad={() => {
                        this.setState({
                          showStudentIdCard: false,
                        });
                      }}
                    />
                  </>
                )}
              </div>
            </div>
          </div>

          {this.state.isOpenSelectStudent && (
            <MdlSelectMultipleStudent
              actionClose={this.HandleCloseSelectStudent}
              actionHandleSelected={this.HandleSelectedStudent}
            />
          )}
        </div>
      );
    }
  }
}
